import React from 'react'
import Colors from 'utils/Colors'
import { maskString } from 'utils/functions'
import AccessTimeIcon from '@mui/icons-material/AccessTime'
import moment from 'moment'
import { IconButton, Tooltip } from '@mui/material'
import LaunchIcon from '@mui/icons-material/Launch'
import { determineTooltipDetails, gatherModelWarnings } from 'utils/warnings'
import WarningIcon from 'components/WarningTooltip'
import RemoveIcon from '@mui/icons-material/Remove'
import styles, { TableColumn } from './styles'
import { BGC_FIELDS } from '../../../utils/constants/bgcFields'
import {
  PROCESS_STATUS,
  PROCESS_STATUS_MESSAGES,
} from '../../../utils/constants/kypStatuses'
import BuildBgcRowFields from '../BackgroundCheckDataBuilder'

const BackgroundCheckRow = (props) => {
  const { background_check, onClick } = props
  const classes = styles()
  const excludedFields = [BGC_FIELDS.financial_situation]

  const renderFieldStatus = () => {
    return background_check?.status === PROCESS_STATUS.ERROR ? (
      <RemoveIcon style={{ color: Colors.gray }} />
    ) : (
      <AccessTimeIcon style={{ color: Colors.gray }} />
    )
  }

  const renderName = () => {
    const result = gatherModelWarnings(background_check?.person)
    if (result.anyWarning) {
      const tooltipDetails = determineTooltipDetails(result)
      return (
        <WarningIcon
          message={tooltipDetails.message}
          color={tooltipDetails.color}
        />
      )
    }

    return background_check?.person?.name
      ? background_check?.person?.name
      : renderFieldStatus()
  }

  return (
    <tr id={background_check?.uuid} key={background_check.uuid}>
      <td>{moment(background_check?.created).format('DD/MM/yyyy HH:mm:SS')}</td>
      <TableColumn>{renderName()}</TableColumn>
      <td>{maskString(background_check?.person?.cpf, 'cpf')}</td>
      <td>
        {background_check?.person?.birth_date
          ? moment(background_check?.person?.birth_date).format('DD/MM/yyyy')
          : renderFieldStatus()}
      </td>
      <td>{PROCESS_STATUS_MESSAGES[background_check.status]}</td>

      {BuildBgcRowFields(background_check, excludedFields)}

      <td>
        <div className={classes.detailsContent}>
          <Tooltip
            arrow
            placement="top"
            title={
              <b className={classes.tooltipText}>
                Visualizar as informações
                <br />
                detalhadas do background check
              </b>
            }
          >
            <IconButton
              id={background_check.uuid}
              onClick={onClick}
              size="large"
            >
              <LaunchIcon
                style={{
                  color: Colors.primaryColor,
                  fontSize: 20,
                }}
              />
            </IconButton>
          </Tooltip>
        </div>
      </td>
    </tr>
  )
}

export default BackgroundCheckRow
